export const title = ''
export const pageLimit = 20 // table 请求每页数据
export const asideWith = 200 // 左侧导航宽度
export const headerHeight = 60 // 左侧导航宽度
export const isShowTabs = true // 是否显示头部导航
export const openTabs = true // 是否开启标签页样式导航
export const openBreadcrumb = true // 是否开启面包屑导航
export const constantTab = []
/* export const cpConstantTab = [{
  path: '/programManagement',
  name: '节目管理'
}] */

export default {
  title,
  pageLimit,
  asideWith,
  headerHeight,
  constantTab,
  isShowTabs,
  openTabs,
  openBreadcrumb
}
